import { Component, OnInit, Input } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { OrderByPipe } from './../../../../shared/pipe/order-by.pipe';
import { EmployeeService } from '../../../../pages/employee/services/employee.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { concat } from 'rxjs';

@Component({
  selector: 'app-edit-vendor-modal',
  templateUrl: './edit-vendor-modal.component.html',
  styleUrls: ['./edit-vendor-modal.component.css'],
})
export class EditVendorModalComponent implements OnInit {
  @Input() data: any;
  orderByPipe: any;
  selectedPRGroup: any = {};
  prGroupObservables: any = {};
  alert: { [key: string]: any } = {};

  constructor(
    private employeeService: EmployeeService,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    this.orderByPipe = new OrderByPipe();
    this.registerObservables();
    this.alert = null;
  }

  registerObservables() {
    this.prGroupObservables['prGroupInput$'] = new Subject<any>();
    this.prGroupObservables['prGroup$'] = new Observable<any>();
    this.prGroupObservables['prGroup$'] = concat(
      this.prGroupObservables['prGroupInput$'].pipe(
        debounceTime(500),
        distinctUntilChanged(),
        switchMap(async (term: any) => {
          const result: any = await this.employeeService.getVendors(term).catch((error: any) => {
            this.alert = { type: 'danger', msg: error?.error?.error ?? 'An error has occured.' };
          });
          result.forEach((val: any, key) => {
            val.VendorFullName = val.VendorName + ' (Group ' + val.VendorGroup + ')';
          });
          return result;
        })
      )
    );
  }

  public saveClicked() {
    this.data.ExpenseAPVMKeyID = this.selectedPRGroup.Value.APVMKeyID;
    this.activeModal.close('save');
  }

  public cancelClicked() {
    this.activeModal.close('cancel');
  }
}
